export default {
  "home.title": "الرئيسية",
  "home.subtitle": "ملخص أعمال المغسلة اليوم",
  "home.today": "تاريخ اليوم",
  "home.refresh": "تحديث",

  "home.cards.new": "الطلبات الجديدة",
  "home.cards.newHint": "بانتظار قبول المغسلة أو رفضها",
  "home.cards.inProgress": "الطلبات قيد التنفيذ",
  "home.cards.inProgressHint": "الطلبات الجارية قيد التنفيذ فقط",
  "home.cards.completedToday": "الطلبات المكتملة اليوم",
  "home.cards.completedHint": "وفق تأكيد الاستلام",
  "home.cards.revenue": "إيرادات اليوم",
  "home.cards.revenueHint": "قيمة الطلبات المكتملة اليوم قبل العمولة — وهي نفسها إيرادات الطلبات المباشرة في صفحة المالية.",

  "home.newOrders.title": "الطلبات الجديدة",
  "home.newOrders.subtitle": "طلبات بانتظار قرار المغسلة",
  "home.newOrders.viewAll": "عرض الطلبات الجديدة",
  "home.newOrders.empty": "لا توجد طلبات جديدة بانتظار القبول",
  "home.newOrders.col.order": "رقم الطلب",
  "home.newOrders.col.customer": "العميل",
  "home.newOrders.col.priority": "الأولوية",
  "home.newOrders.col.fulfillment": "الاستلام والتسليم",
  "home.newOrders.col.total": "المبلغ الإجمالي",
  "home.newOrders.col.status": "الحالة",
  "home.newOrders.col.action": "إجراء",

  "home.escalation.title": "طلبات تحتاج تدخلًا يدويًا",
  "home.escalation.subtitle": "طلبات في مرحلة التسليم تحتاج تعيين مندوب",
  "home.escalation.empty": "لا توجد طلبات تحتاج تدخلًا يدويًا",
  "home.escalation.badge": "يحتاج تعيين مندوب",
  "home.escalation.reason": "اختار العميل الانتظار وانقضت المهلة دون قبول مهمة التسليم",
  "home.escalation.viewOrder": "عرض الطلب",
  "home.escalation.note": "المهمة تظل متاحة للمندوبين بالتوازي، ويمكن تعيين مندوب تابع من تفاصيل الطلب.",

  "home.summaryError": "تعذّر تحميل ملخص الأداء",
  "home.ordersError": "تعذّر تحميل الطلبات الجديدة",
  "home.escalationError": "تعذّر تحميل التنبيهات"
};